<template lang="html">
  <div style="overflow-y: scroll; height: 100vh; padding-left: 20px">
    <pl-button @click.native="$router.go(-1)" class="pl-primary"
      >Go Back
    </pl-button>
    <h1 style="display: inline-block">{{ district.name }}</h1>

    <!-- Membership Details -->
    <div class="mv4">
      <div class="pl-headline">Membership Details</div>

      <h2>Memberships</h2>
      <ul>
        <li
          class="pl-subheading"
          v-for="membership in district.district_memberships"
        >
          <strong>Expiry Date</strong>: {{ membership.end_date_readable }}
          <br />
          <strong>Date Started</strong>: {{ membership.start_date_readable }}
        </li>
      </ul>

      <div class="pl-title">Create new membership</div>
      <div class="pl-subheading">
        NOTE: creating a district membership creates one for all teachers in
        that district
      </div>
      <div class="pl-subheading">
        If possible, please perform this action after school hours
      </div>
      <!-- Membership Date Picker -->
      <fieldset>
        <legend>Choose Membership Duration</legend>

        <div>
          <label for="start">Start Date</label>
          <input
            v-model="start_date"
            type="date"
            id="start"
            name="membership-selection"
            required
          />
        </div>

        <div>
          <label for="end">End Date</label>
          <input
            v-model="end_date"
            type="date"
            id="end"
            name="membership-selection"
            required
          />
        </div>
      </fieldset>
      <pl-button
        v-if="!creating_district_membership"
        class="pl-primary"
        @click.native="createNewDistrictMembership"
      >
        Create New
      </pl-button>
      <pl-spinner v-else />
    </div>

    <!-- Schools list -->
    <div class="pl-headline">
      {{ district.schools.length }} schools -
      <pl-button
        class="pl-primary"
        @click.native="expand_schools = !expand_schools"
      >
        {{ expand_schools ? 'Hide' : 'Show' }}
      </pl-button>
    </div>

    <ul v-if="expand_schools" class="pl-title">
      <li
        class="clickable"
        @click="selectSchool(school)"
        v-for="(school, index) in district.schools"
      >
        {{ school.name }}
      </li>
    </ul>
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        expand_schools: false,
        creating_district_membership: false,
        district: {
          schools: [],
          district_memberships: [],
          name: 'District',
        },
        start_date: '',
        end_date: '',
        districtID: this.$route.params.districtID,
      };
    },
    methods: {
      createNewDistrictMembership() {
        if (!this.start_date || !this.end_date) {
          return null;
        }
        const payload = {
          start_date: this.start_date,
          end_date: this.end_date,
        };
        this.creating_district_membership = true;
        adminServices
          .createDistrictMembership(this.districtID, payload)
          .then((res) => {
            this.district.district_memberships.push(res.data);
            this.creating_district_membership = false;
            this.start_date = '';
            this.end_date = '';
            EventBus.$emit('toast-msg', 'success');
          })
          .catch(() => {
            EventBus.$emit(
              'alert-msg',
              'An error occured. No memberships created. Refresh and try again.'
            );
            this.creating_district_membership = false;
          });
      },
      selectSchool(school) {
        this.$router.push(
          `/admin-view-individual-school/${school.id}?name=${school.name}`
        );
      },
      getDistrictData() {
        adminServices.getDistrict(this.districtID).then((res) => {
          this.district = res.data;
        });
      },
    },
    mounted() {
      this.getDistrictData();
    },
  };
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// viewIndividualDistrict.vue?e92d7606